const chartsData = {
  labels: ["Dummy-1", "Dummy-2", "Dummy-3", "Dummy-4", "Dummy-5", "Dummy-6"],
  datasets: [2, 2, 2, 1, 4, 1],
};

export default chartsData;
